import React, { useEffect, useState } from 'react';
import { Button, Form, Radio, FormTitle, useBreadcrumbRoutes, Wrapper, SubContent } from '@maxtropy/components';
import { OrgDataPermissionType, OrgDataPermissionTypeDisplay, OuOperationType, OuOperationTypeDisplay } from './util';
import { Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { apiV2StaffBatchPermissionPost } from '@maxtropy/cc-customer-apis-v2';
import UserModal from './components/userModal';
import OuModal, { OuResponse } from './components/OuModal';
import OrgModal from './components/OrgModal';

const FormItem = Form.Item;

const BatchConfigurePermissions = () => {
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [userVisible, setUserVisible] = useState<boolean>(false);
  const [ouVisible, setOuVisible] = useState<boolean>(false);
  const [orgVisible, setOrgVisible] = useState<boolean>(false);

  const [form] = Form.useForm();
  const ouOperationType: OuOperationType = Form.useWatch('ouOperationType', form) ?? OuOperationType.ADMINISTRATOR;
  const tenantOperationType: OrgDataPermissionType =
    Form.useWatch('tenantOperationType', form) ?? OrgDataPermissionType.ADD;

  useEffect(() => {
    form.setFieldsValue({
      ouOperationType: OuOperationType.ADMINISTRATOR,
      tenantOperationType: OrgDataPermissionType.ADD,
    });
  }, []);

  const handleClick = () => {
    const values = form.getFieldsValue(true);
    const params = {
      ...values,
      staffIdList: values.staffIdList?.map((item: any) => item.id),
      ouIdList: values.ouIdList?.map((item: any) => item.id),
    };
    setLoading(true);
    apiV2StaffBatchPermissionPost(params)
      .then(() => {
        navigate(`/system/customer/staff`);
      })
      .finally(() => setLoading(false));
  };

  return (
    <Wrapper routes={[...(breadcrumbRoutes?.routes ?? []), { name: `批量配置权限` }]}>
      <FormTitle title="批量配置权限" />
      <SubContent>
        <Form form={form} labelCol={{ style: { width: 160, maxWidth: 154 } }}>
          <FormItem label="员工" name="staffIdList">
            <Button type="primary" onClick={() => setUserVisible(true)}>
              选择用户
            </Button>
          </FormItem>
          <FormItem label="运营单元操作类型" name="ouOperationType">
            <Radio.Group
              onChange={() => {
                form.setFieldValue('ouIdList', undefined);
              }}
            >
              {Object.entries(OuOperationTypeDisplay).map(([key, value]) => (
                <Radio key={Number(key)} value={Number(key)}>
                  {value}
                </Radio>
              ))}
            </Radio.Group>
          </FormItem>
          <FormItem label="配置运用单元" name="ouIdList">
            <Button type="primary" onClick={() => setOuVisible(true)}>
              {OuOperationTypeDisplay[ouOperationType]}
            </Button>
          </FormItem>
          <FormItem label="组织数据权限操作类型" name="tenantOperationType">
            <Radio.Group
              onChange={() => {
                form.setFieldValue('mcidList', undefined);
              }}
            >
              {Object.entries(OrgDataPermissionTypeDisplay).map(([key, value]) => (
                <Radio key={Number(key)} value={Number(key)}>
                  {value}
                </Radio>
              ))}
            </Radio.Group>
          </FormItem>
          <FormItem label="配置组织数据权限" name="mcidList">
            <Button type="primary" onClick={() => setOrgVisible(true)}>
              {OrgDataPermissionTypeDisplay[tenantOperationType]}
            </Button>
          </FormItem>
        </Form>
        <Space style={{ marginTop: 24 }}>
          <Button type="primary" onClick={handleClick} loading={loading}>
            保存
          </Button>
          <Button onClick={() => navigate(`/system/customer/staff`)}>取消</Button>
        </Space>
      </SubContent>
      {userVisible && (
        <UserModal
          onCancel={() => {
            setUserVisible(false);
          }}
          selectedData={form.getFieldValue('staffIdList') ?? []}
          setSelectedData={staffIdList => {
            form.setFieldsValue({ staffIdList });
          }}
          form={form}
        />
      )}
      {ouVisible && (
        <OuModal
          type={form.getFieldValue('ouOperationType')}
          onCancel={() => {
            setOuVisible(false);
          }}
          selectedOuData={form.getFieldValue('ouIdList') ?? []}
          setSelectedOuData={(selectedOus: OuResponse[]) => {
            form.setFieldsValue({ ouIdList: selectedOus });
          }}
        />
      )}
      {orgVisible && (
        <OrgModal
          type={form.getFieldValue('tenantOperationType')}
          onCancel={() => {
            setOrgVisible(false);
          }}
          selectedData={form.getFieldValue('mcidList') ?? []}
          setSelectedData={mcidList => {
            form.setFieldsValue({ mcidList });
          }}
        />
      )}
    </Wrapper>
  );
};

export default BatchConfigurePermissions;
